import React, { Fragment } from 'react';
import R from 'ramda';
import PropTypes from 'prop-types';
import {
  getBreakpointConfig,
  getIsContentFirst,
  breakpointPropShape,
} from '../helpers';

const CardoBody = ({
  image,
  content: Content,
  xsmall,
  small,
  medium,
  large,
  xlarge,
  currentBreakpoint,
}) => {
  const breakpointConfig = getBreakpointConfig({
    currentBreakpoint,
    xsmall,
    small,
    medium,
    large,
    xlarge,
  });

  const {
    contentAlignment,
    contentOverlay,
  } = breakpointConfig;

  const imageColumns = R.path(['gridSetup', 'image', 'columns'], breakpointConfig);
  const contentColumns = R.path(['gridSetup', 'content', 'columns'], breakpointConfig);
  const swatchLimit = R.prop('swatchLimit', breakpointConfig);

  const isContentFirst = getIsContentFirst({
    contentAlignment,
    contentOverlay,
    imageColumns,
    contentColumns,
  });

  return (
    <Fragment>
      <Content
        contentAlignment={contentAlignment}
        contentOverlay={contentOverlay}
        isContentFirst={isContentFirst}
        imageColumns={imageColumns}
        contentColumns={contentColumns}
        swatchLimit={swatchLimit}
      />
      { image }
    </Fragment>
  );
};

CardoBody.propTypes = {
  image: PropTypes.node,
  content: PropTypes.func.isRequired,
  xsmall: breakpointPropShape,
  small: breakpointPropShape,
  medium: breakpointPropShape,
  large: breakpointPropShape,
  xlarge: breakpointPropShape,
  currentBreakpoint: PropTypes.string.isRequired,
};

export default CardoBody;
